import { Component, OnInit } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-photogallery',
  templateUrl: './photogallery.component.html',
  styleUrls: ['./photogallery.component.css']
})
export class PhotogalleryComponent implements OnInit {

  constructor(private mS: MainService) { }

	public carouselOne: NgxCarousel;

  ngOnInit() {
    this.mS.scrollToTop(500);
  	this.carouselOne = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/photogallery/photogallery.component.ts